<script>
import { defineComponent } from "vue";
import DemoNarrationBar from "./components/demo/DemoNarrationBar.vue";
import DemoLoopPicker from "./components/demo/DemoLoopPicker.vue";
import { useDemoLoopStore } from "@/javascript/stores/demoLoop";

export default defineComponent({
  components: { DemoNarrationBar, DemoLoopPicker },
  setup() {
    // Eagerly initialize the demo loop store so global keyboard listeners register
    useDemoLoopStore();
  }
});
</script>

<template>
  <div>
    <router-view />
    <DemoNarrationBar />
    <DemoLoopPicker />
  </div>
</template>

<style lang="scss" scoped>
</style>
